import React from 'react';
import Type from './Type';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import { BsFacebook, BsGithub, BsTwitter } from 'react-icons/bs';



const Hero = () => {
  return (
    <div className='mt-4 text-gray-300 py-2' id="about">
   
    

   
        <h1 className='text-2xl font-bold'>01.<span className='text-primary mb-6'>About_Me</span></h1>
        <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 py-2">You can know everything about me. </h1>

        <div className='grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 mt-2 py-6  items-center'>

          <div className=' grid justify-center'>
            <div className="box">

              <div className="content">

                <img src="https://i.ibb.co/93mNpq0/IMG-20230803-WA0008.jpg" class="lg:w-[425px] h-[400px] shadow-5xl" alt="net problem" />

              </div>
            </div>
          </div>

          <div className="grid justify-center text-gray-300 gradient">

            <h1 class="mb-1 lg:text-3xl text-2xl "><span className='text-primary '>Hi, </span>I am Mozahidul Islam</h1>

            <h1 className='h1p lg:text-3xl  text-2xl  '><Type></Type></h1>
            <p class="mb-4 text-base font-normal h1p text-gray-500 dark:text-gray-400 ">Mission, Learning, Hardwork, Capture, Success. </p>

            <h1>I am always ready to learn new technology/language/framework to keep myself update with the latest market trends. <br />
            i'm a expert designer developer and problem solver and error handler.
            </h1>
            <div className="flex gap-5 mt-4">
              <a href="https://github.com/mozahidahmed/">
                <div className="text-2xl text-sky-300"><BsGithub /></div>
              </a>

              <a href="https://www.facebook.com/profile.php?id=100048932201779">
                <div className="text-2xl text-cyan-600"><BsFacebook /></div>
              </a>


              <a href="https://www.linkedin.com/in/IslamMozahidul/">
                <div className="text-2xl "><AiFillLinkedin /></div>
              </a>


              <div className="text-2xl text-sky-500"><BsTwitter /></div>
            </div>

          </div>

        </div>

 


    </div>
  );
};

export default Hero;